import { SimpleLocalizedError, type Localizable } from "@/modules/l10n/getTransText.ts";
import { msg } from "@lingui/core/macro";
import type { PaymentResultResponse } from "@warrenio/api-spec/spec.oats.gen";

/** @public */
export class ClictopayError extends SimpleLocalizedError {
    name = "ClictopayError";

    constructor(
        public readonly code: "failed" | "other",
        localeMessage: Localizable,
    ) {
        super(localeMessage);
    }
}

export function parseClictopayPaymentResult(response: PaymentResultResponse) {
    switch (response.status) {
        case "success":
            return response;
        case "failed":
            throw new ClictopayError("failed", response.message ?? msg`Payment failed`);
        default:
            return null; // status still pending
    }
}
